import { render, staticRenderFns } from "./ShouninStatus.vue?vue&type=template&id=7bdeb15f&scoped=true&"
import script from "./ShouninStatus.vue?vue&type=script&lang=ts&"
export * from "./ShouninStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdeb15f",
  null
  
)

export default component.exports